<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <GlobalHeader/>
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import {
  ACCESS_TOKEN,
  ACCESS_SUNID
} from '@/store/mutation-types'
import NProgress from 'nprogress'
import { mapState } from 'vuex'
import { getAntLangPack } from '@/locales'
import GlobalHeader from '@/components/GlobaHeader/Header'
// import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  components: {
    GlobalHeader
  },
  data () {
    return {
      getAntLangPack
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang
    }),
    locale () {
      return getAntLangPack(this.currentLang)
    }
  },
  created () {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://g.alicdn.com/dingding/open-develop/1.9.0/dingtalk.js'
    window.document.head.appendChild(script)

    // 国旗
    let iconfontPlugByFlag = document.createElement('script')
    iconfontPlugByFlag.src = '//at.alicdn.com/t/font_2685038_37xw2t9n52x.js'
    iconfontPlugByFlag.async = true
    document.body.appendChild(iconfontPlugByFlag)
  },
  mounted () {
    NProgress.start()
    // 给页面设置请求加载进度条效果
    window.onload = function () {
      NProgress.done()
    }
    // 闭窗口之后执行
    window.onunload = function (e) {
      this.$ls.remove(ACCESS_TOKEN)
      this.$ls.remove(ACCESS_SUNID)
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#nprogress .bar {
  background: #4A78D6 !important; //自定义颜色
}
.anticon.ant-notification-notice-icon-warning {
  font-size: 24px!important;
}
</style>

<style lang="less" scoped>
.popoverClasses {
  max-width: 70vh;
  max-height: 20vh;
  overflow: auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  background: #404040;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  opacity: 0.95;
  border-radius: 4px;
  padding: 12px 16px;
  &::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
    // border: 2px #fff solid;
  }
}
</style>
